import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { OrderFormShortRowGridItem } from "../../styles";

export const ShiftInfoHeadersRow = () => {
  const { t } = useTranslation("order");

  return (
    <Grid item container xs={12} direction="row" mt={1}>
      <Grid
        item
        xs={12}
        container
        spacing={1}
        sx={{
          alignItems: "center",
          paddingLeft: "1rem",
          color: "text.secondary",
        }}
      >
        <OrderFormShortRowGridItem item xs={2}>
          <Typography>{t("date")}</Typography>
        </OrderFormShortRowGridItem>
        <OrderFormShortRowGridItem item xs={2} width="160px">
          <Typography>{t("time")}</Typography>
        </OrderFormShortRowGridItem>
        <OrderFormShortRowGridItem item xs={3} width="200px">
          <Typography>{t("customerCostCenter")}</Typography>
        </OrderFormShortRowGridItem>
        <OrderFormShortRowGridItem item xs={4}>
          <Typography>{t("talent")}</Typography>
        </OrderFormShortRowGridItem>
      </Grid>
    </Grid>
  );
};
